import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TimeConverterProvider } from '@services/helpers/time-converter';
import { SettingsProvider } from '@services/settings/settings';

@Injectable()
@Pipe({
	name: 'timeFilter'
})
export class TimeFilterPipe implements PipeTransform {
	constructor(
		public datePipe: DatePipe,
		private timeConverter: TimeConverterProvider,
		private settingsService: SettingsProvider
	) {}

	private dateFormat: string;
	private timeFormat: string;

	transform(date: string, type: string) {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.dateFormat = data.dateFormat;
			this.timeFormat = data.timeFormat;
		});

		// check if we need a time or a date value
		if (type.includes('12h') || type === 'hourAndMin') {
			return this.timeFormat === 'T_24'
				? this.transformISO(date, type)
				: this.transformEnglish(date, type);
		}

		return this.dateFormat === 'DD_MM_YYYY'
			? this.transformISO(date, type)
			: this.transformEnglish(date, type);
	}

	private transformEnglish(date: string, type: string) {
		let output;

		if (!date) {
			return '';
		}
		switch (type) {
			case '12h':
				output = this.timeConverter.convert24to12(date);
				break;
			case 'hourAndMin':
				output = this.datePipe.transform(date, 'hh:mm a');
				break;
			case '12hL':
				output = this.timeConverter.convert24to12(date).toLocaleLowerCase();
				break;
			case '12hLS':
				output = this.timeConverter
					.convert24to12(date)
					.toLocaleLowerCase()
					.replace(' ', '');
				break;
			case 'long':
				output = this.datePipe.transform(date, 'MMMM dd yyyy');
				break;
			case 'medium':
				output = this.datePipe.transform(date, 'MMM dd yyyy');
				break;
			case 'dayAndMonth':
				output = this.datePipe.transform(date, 'MMM dd');
				break;
			case 'dayAndLongMonth':
				output = this.datePipe.transform(date, 'MMMM dd');
				break;
			default:
				output = '';
		}

		return output;
	}

	private transformISO(date: string, type: string) {
		let output;

		if (!date) {
			return '';
		}
		switch (type) {
			case '12h':
				output = date.substring(0, 5);
				break;
			case 'hourAndMin':
				output = this.datePipe.transform(date, 'HH:mm');
				break;
			case '12hL':
				output = date.substring(0, 5);
				break;
			case '12hLS':
				output = date.substring(0, 5);
				break;
			case 'long':
				output = this.datePipe.transform(date, 'dd MMMM yyyy');
				break;
			case 'medium':
				output = this.datePipe.transform(date, 'dd MMM yyyy');
				break;
			case 'dayAndMonth':
				output = this.datePipe.transform(date, 'dd MMM');
				break;
			case 'dayAndLongMonth':
				output = this.datePipe.transform(date, 'dd MMMM');
				break;
			default:
				output = '';
		}

		return output;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/pipes/time-filter/time-filter.ts